export enum FeatureFlagKeys {
  EnableClientLogo = 'EnableClientLogo',
  NewHomePage = 'NewHomePage',
  NewOrderTablePage = 'NewOrderTablePage',
  NewProductVariantPage = 'NewProductVariantPage',
  NewBasketPopup = 'NewBasketPopup',
  NewOneStepCheckoutPage = 'NewOneStepCheckoutPage',
  NewProductDetails = 'NewProductDetails',
  NewBasketDrawer = 'NewBasketDrawer',
  NewOrderDetailsPage = 'NewOrderDetailsPage',
  NewGlobalSearch = 'NewGlobalSearch',
  NewProductCataloguePage = 'NewProductCataloguePage',
  NewGaCheckoutDrawer = 'NewGaCheckoutDrawer',
  NewAccessProgramsPage = 'NewAccessProgramsPage'
}
